import React, { useRef } from "react";
import "antd/dist/antd.css";
import i18next from "i18next";
import { withTranslation } from "react-i18next";
import i18n from "../../i18n";
import { Editor } from "@tinymce/tinymce-react";
import { updateCommentSentencePopoversLater } from './HTMLEditor';
import * as Helper from "../../utils/Helper";
import "./HTMLEditor.css";
import AppConfig from "../../config/AppConfig";

import UIDs from "../../UIDs";
const uid = UIDs.components.ui.htmleditor;

const getTextSize = (s, maxWidth) => {
    let text = document.createElement("span");
    document.body.appendChild(text);

    //text.style.font = "times new roman";
    text.style.fontSize = 14 + "px";
    text.style.height = "auto";
    if (maxWidth) {
        text.style.width = maxWidth + "px";
    } else {
        text.style.width = "auto";
    }
    text.style.position = "absolute";
    text.style.whiteSpace = "pre-wrap";
    text.style.lineHeight = "30px";
    text.innerText = s;

    let width = Math.ceil(text.clientWidth);
    let height = Math.ceil(text.clientHeight);

    document.body.removeChild(text);
    return { width, height };
};

const updatePopoverPos = (rootNode, n) => {
    let parentNode = n.parentNode;
    let parentRect = parentNode.getBoundingClientRect();
    if (rootNode.parentNode && rootNode.parentNode.getBoundingClientRect) {
        rootNode = rootNode.parentNode;
    }

    let rootRect = rootNode.getBoundingClientRect();
    let { width, height } = getTextSize(n.textContent);
    let maxWidth = parseInt(rootRect.width / 2);
    if (width > maxWidth) {
        let newSize = getTextSize(n.textContent, maxWidth);
        width = newSize.width;
        height = newSize.height;
    }

    const padding = 4;
    width += padding * 2 + 20;
    height += padding * 2;

    let left = parentRect.left;
    let top = parentRect.top - height - 8 - 12;
    if (left + width > rootRect.left + rootRect.width - 20) {
        left = rootRect.left + rootRect.width - width - 20;
    }

    if (top < rootRect.top) {
        top = parentRect.bottom + 8;
    }

    //n.style.font = "times new roman";
    n.style.fontSize = 14 + "px";
    n.style.paddingTop = 8 + "px";
    n.style.paddingLeft = 8 + "px";
    n.style.width = width + "px";
    n.style.height = height + "px";
    n.style.left = left - parentRect.left + "px";
    n.style.top = top - parentRect.top + "px";
    n.style.whiteSpace = "pre-wrap";
    n.style.lineHeight = "30px";
};

const adjustPopover = (rootNode, n) => {
    /* NOTE: 已改成updateCommentSentencePopoversLater
    const childNodes = n.childNodes;
    for (let i = 0; i < childNodes.length; ++i) {
        const child = childNodes[i];
        if (child.className && child.className.indexOf("aic-comment-sentence-popover") >= 0) {
            updatePopoverPos(rootNode, child);
        }
        adjustPopover(rootNode, child);
    }
    */
};

const updateLinks = (rootNode, n) => {
    const childNodes = n.childNodes;
    for (let i = 0; i < childNodes.length; ++i) {
        const child = childNodes[i];
        if (child.nodeName === 'A' || child.nodeName === 'a') {
            child.target = '_blank';
        }
        updateLinks(rootNode, child);
    }
};

const updateImages = (rootNode, n) => {
    const childNodes = n.childNodes;
    for (let i = 0; i < childNodes.length; ++i) {
        const child = childNodes[i];
        if (child.nodeName === 'IMG' || child.nodeName === 'img') {
            child.style.cursor = 'pointer';
            child.onclick = () => {
                window.open(child.src);
            };
        }
        updateImages(rootNode, child);
    }
};

class HTMLView extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (!this._timer) {
            this._timer = setInterval(this._updatePopover, 1000);
        }
    }

    componentWillUnmount() {
        if (this._timer) {
            clearInterval(this._timer);
            this._timer = null;
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.html !== this.props.html) {
            this.renderHtml();
        }
    }

    renderHtml() {
        if (this._ref) {
            this._ref.innerHTML = Helper.replaceHtmlVirtualPath(this.props.html);
            if (this._popoverTimer) {
                clearTimeout(this._popoverTimer);
                this._popoverTimer = null;
            }

            this._popoverTimer = setTimeout(() => {
                if (this._popoverTimer) {
                    this._popoverTimer = null;
                }

                if (this._ref) {
                    adjustPopover(this._ref, this._ref);
                    if (this.props.openLinkInNewTab !== false) {
                        updateLinks(this._ref, this._ref);
                    }
                    if (this.props.enableZoomImage !== false) {
                        updateImages(this._ref, this._ref);
                    }

                    this._ref.enableAsr = this.props.enableAsr;
                    updateCommentSentencePopoversLater();
                }
            }, 500);
        }
    }

    _updatePopover = () => {
        if (this._ref) {
            //adjustPopover(this._ref, this._ref);
        }
    };

    setupRef = (r) => {
        this._ref = r;
        this.renderHtml();
    };

    render() {
        const { html, injectStyle, ...props } = this.props;
        return (
            <div style={{overflowX: 'auto'}}>
                {injectStyle ? <style> {injectStyle} </style> : null}
                <div className="htmlview" ref={this.setupRef} {...props} />
            </div>
        );
    }
}

export default withTranslation(uid)(HTMLView);
